export const FilterAttractions = (parent, datas, id) => {
    const collection = [];
    const map = new Map();
    if (parent === 'park' && !datas.errno) {
        for (const el of datas) {
            if (!map.has(el.aslug) && el.pid === id) {
                map.set(el.aslug, true);
                collection.push({
                    pslug: el.pslug,
                    uslug: el.uslug,
                    cslug: el.cslug,
                    ccode: el.ccode,
                    aid: el.aid,
                    aname: el.aname,
                    aslug: el.aslug,
                    aroute: el.aroute,
                });
            }
        }
    }
    if (parent === 'univers' && !datas.errno) {
        for (const el of datas) {
            if (!map.has(el.aslug) && el.uid === id) {
                map.set(el.aslug, true);
                collection.push({
                    pslug: el.pslug,
                    uslug: el.uslug,
                    cslug: el.cslug,
                    ccode: el.ccode,
                    aid: el.aid,
                    aname: el.aname,
                    aslug: el.aslug,
                    aroute: el.aroute,
                });
            }
        }
    }
    return collection;
}
